import groupBy from 'lodash/groupBy';

export const measurementsForSubject = (
  measurements: { subject: { id: string } }[],
  subjectId: string
) => measurements.filter((m: any) => m.subject.id === subjectId);

export const measurementsForTracker = (
  measurements: { tracker: { id: string } }[],
  trackerId: string
) => measurements.filter((m: any) => m.tracker.id === trackerId);

export const groupBySubject = (measurements: { subject: { id: string } }[]) => {
  const grouped = groupBy(measurements, measurement => measurement.subject.id);
  const value: any = [];

  Object.keys(grouped).forEach(key => {
    value.push({
      ...grouped[key][0].subject,
      measurements: [...grouped[key]]
    });
  });

  return value;
};

export const groupByTracker = (measurements: { tracker: { id: string } }[]) => {
  const grouped = groupBy(measurements, measurement => measurement.tracker.id);
  const value: any = [];

  Object.keys(grouped).forEach(key => {
    value.push({
      tracker: grouped[key][0].tracker,
      measurements: [...grouped[key]]
    });
  });

  return value;
};

export default groupBySubject;
